import { Component, Input, OnInit, Output,EventEmitter  } from '@angular/core';
import { ApplicationConfigService } from 'src/service/application-config.service';

export class KeyValueConfig {
  public key: string;
  public name: string;
  public type: string;
  public min: number;
  public max: number;
  public step: number;
}

@Component({
  selector: 'app-key-value-editor',
  templateUrl: './key-value-editor.component.html',
  styleUrls: ['./key-value-editor.component.scss']
})
export class KeyValueEditorComponent implements OnInit {
  private _json: string;
  private _object: any;
  @Input() 
  set json(value: string) {
    this._json = value;
    this.onJsonChange(); // Call the method to execute when json is set
  }

  get json(): string {
    return this._json;
  }

  @Input() config: KeyValueConfig[];
  
  @Output() jsonChange = new EventEmitter<string>();

  constructor(public app: ApplicationConfigService) {

  }

  ngOnInit() {
  }

  onJsonChange() {
    if (this._json == null || this._json == ''){
      this._object = {};
      for (let key of this.config){
        this._object[key.key] = '';
      }
    } else {
      this._object = JSON.parse(this._json);
    }
  }

  update(){
    this._json = JSON.stringify(this._object);
    console.log(this.json);
    this.jsonChange.emit(this._json);
  }
}
